<script setup lang="ts">
import BackgroundBanner from '~/components/effects/BackgroundBanner.vue'

defineOptions({
	name: 'ModalAllBalls',
})

const emit = defineEmits(['update:modelValue', 'updateStatusForm'])

interface Props {
	modelValue?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	modelValue: false,
})

const isOpen = computed({
	get() {
		return props.modelValue
	},
	set(value) {
		emit('update:modelValue', value)
	},
})
</script>

<template>
	<ClientOnly>
		<UModal
			v-model="isOpen"
			:ui="{
				overlay: {
					background: 'bg-[#040404D4] bg-opacity-80',
				},
				width: 'w-full sm:max-w-[592px]',
				container: 'items-center',
				padding: 'p-8 sm:p-0',
			}"
		>
			<div class="bg-secondary-700 smm:bg-secondary-900">
				<div class="w-full relative z-10 py-5 pb-10 sm:pb-10 sm:py-10 px-4 sm:px-8 rounded-lg sm:rounded-3xl">
					<BackgroundBanner />
					<div class="space-y-4">
						<div class="flex justify-end">
							<UButton
								color="white"
								variant="link"
								size="xl"
								icon="i-heroicons-x-mark-20-solid"
								class="text-neutral-50"
								@click="isOpen = false"
							/>
						</div>
						<slot />
					</div>
				</div>
			</div>
		</UModal>
	</ClientOnly>
</template>
